import React from "react"
import { useContext, useCallback } from 'react'
import DodoneInnerIgnoreButton from 'app/dodones/shared/InnerIgnoreButton'
import DodoneInnerPendifyButton from 'app/dodones/shared/InnerPendifyButton'
import { Link } from 'react-router-dom'

export default ({ onNav, ignoreDodone, pendifyDodone, ...dodoneContext }) => {
  const dodone = dodoneContext.dodone

  const onIgnoreDodone = useCallback(() => {
    ignoreDodone()
    if(onNav) onNav()
  }, [ignoreDodone, dodone, onNav])

  const onPendifyDodone = useCallback(() => {
    pendifyDodone()
    if(onNav) onNav()
  }, [pendifyDodone, dodone, onNav])

  const isDayDodone = dodone.dodoable.typeViewPrefix == 'Day'
  const hideIgnoreButton = dodone.isIgnored || isDayDodone

  return <>
           { isDayDodone ? <Link className={ 'text-xl' } to={ "/dodones/days" } onClick={ onNav }> Other Days </Link> : null }
           <DodoneInnerIgnoreButton { ...dodoneContext } ignoreDodone={ onIgnoreDodone }/>
           <DodoneInnerPendifyButton { ...dodoneContext } pendifyDodone={ onPendifyDodone }/>
         </>
}
